const icon = require('vue-svgicon');
icon.register({
    'arrow-right': {
        width: 18,
        height: 18,
        viewBox: '0 0 18 18',
        data: `<path pid="0" d="M16.87 8.952c.066.083.11.178.12.29 0 .011.008.02.008.032l.002.008-.002.008c0 .008-.003.013-.004.02a.565.565 0 01-.145.352c-.008.008-.005.02-.012.028-.008.008-.02.004-.028.011-.007.007-.02.005-.028.012L10.523 15.4a.558.558 0 11-.789-.788l5.236-4.76H1.571a.571.571 0 010-1.141h13.4L9.733 3.95a.557.557 0 11.79-.788l6.226 5.66c.009.006.014.017.022.024.02.015.047.01.065.027.022.022.015.054.033.078z" _fill="#000"/>`,
    },
});
